import React from "react";

const SvgThree = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="223"
    height="158"
    viewBox="0 0 223 158"
    fill="none"
  >
    <path
      d="M222.323 3.45544C210.723 1.16124 197.605 0.11601 185.374 0.173505C95.1505 0.597633 19.9053 67.8379 0.736397 157.696L84.2237 157.304C100.871 115.02 140.008 85.2416 185.773 85.0264C192.77 84.9935 215.68 85.4818 222.323 86.7735L222.323 3.45544Z"
      fill="url(#paint0_linear_969_1079)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_969_1079"
        x1="185.374"
        y1="0.173505"
        x2="186.528"
        y2="245.771"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#55FFF5" />
        <stop offset="1" stop-color="#6AFFF6" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgThree;
